module.exports = __webpack_public_path__ + "static/media/HPP_Collaboration_Icon.f40d06f6.svg";